import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import styled from 'styled-components';

import { BrowserRouter as Router, Route, Switch, withRouter, Link } from 'react-router-dom';
import { selectApiKey } from 'modules/Api/selectors';
import { Card } from '../../../components/Card';
import { Loader } from '../../../components/Loader';
import { Button } from '../../../components/Buttons';
import { BaseComponent } from '../../../components/BaseComponent';
import { selectWork, selectError } from '../../../modules/Api/selectors';
import { Well } from '../../../components/Well';

import * as _ from 'lodash';
import { REQUEST_ACTIVATE } from '../../App/constants';
import { activate } from '../../App/actions';
import styles from './Card.module.css';

// const baseState = {
//   email:'',
//   password:'',
//   password2: '',
//   error : null,
//   agree: false,
//   optin : false,
//   loading: false,
//   complete:false
// }

const baseState = {
  error: null,
  complete: false,
};

/* eslint-disable react/prefer-stateless-function */
class ActivateComp extends BaseComponent {
  constructor(props) {
    super(props, { ...baseState });
  }

  componentDidMount() {
    this.props.activate(result => {
      if (result && result.result) {
        this.setState({ ...baseState, complete: true });
      } else this.setState({ ...baseState, error: true });
    });
  }

  render() {
    if (this.props.loading) return <Loader onCard />;

    return <div center>{this.renderBody()}</div>;
  }

  renderBody() {
    if (this.props.loading) return <Loader fullPage onCard />;

    return (
      <Card
        className={styles.card}
        small
        footer={
          <Button isPrimary onClick={() => this.props.history.push('/login')}>
            {this.lbl('ok')}
          </Button>
        }
      >
        <h1>{this.lbl('login.activate')}</h1>
        {this.state.complete ? (
          <Well success> {this.lbl('login.activate.complete.info')}</Well>
        ) : this.state.error ? (
          <Well error>{this.lbl('login.activate.error.info')}</Well>
        ) : (
          ''
        )}
      </Card>
    );
  }
}

ActivateComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWork(REQUEST_ACTIVATE),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    activate(callback) {
      dispatch(activate({ code: ownProps.code }, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Activate = compose(withRouter, withConnect)(ActivateComp);
